import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { resumenDeMora } from '../utils/mora';

const moneda = (n) => '$' + Math.round(n || 0).toLocaleString('es-CO');

// Aviso de quién está atrasado, visible desde cualquier pantalla al entrar.
//
// La información ya estaba en Morosos, pero había que acordarse de ir. Lo que
// se cobra es lo que se ve: si nadie abre esa pantalla, un cliente puede pasar
// semanas atrasado sin que nadie lo note.
//
// Se puede cerrar, y se queda cerrado hasta el siguiente día. Un aviso que
// reaparece cada vez que cambias de pantalla se vuelve ruido, y el ruido se
// deja de mirar.
const CLAVE_CERRADO = 'aviso-mora-cerrado';

function AvisoDeMora({ onVerMorosos }) {
  const [resumen, setResumen] = useState(null);
  const [cerrado, setCerrado] = useState(
    () => localStorage.getItem(CLAVE_CERRADO) === new Date().toISOString().split('T')[0]
  );

  useEffect(() => {
    let vivo = true;
    axios.get('/api/delinquents')
      .then(res => {
        if (vivo) setResumen(resumenDeMora(res.data?.prestamos || []));
      })
      .catch(() => { /* si falla, no se avisa: mejor callar que alarmar sin datos */ });
    return () => { vivo = false; };
  }, []);

  const cerrar = () => {
    localStorage.setItem(CLAVE_CERRADO, new Date().toISOString().split('T')[0]);
    setCerrado(true);
  };

  if (cerrado || !resumen || resumen.total === 0) return null;

  const primeros = resumen.urgentes.slice(0, 3);
  const restantes = resumen.total - primeros.length;

  return (
    <div style={{
      background: '#fffbeb',
      border: '1px solid #fde68a',
      borderLeft: '4px solid #f59e0b',
      borderRadius: '8px',
      padding: '14px 16px',
      margin: '0 0 18px'
    }}>
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: '12px', flexWrap: 'wrap'
      }}>
        <div style={{ color: '#92400e', fontWeight: 'bold', fontSize: '15px' }}>
          ⚠️ Tienes {resumen.total === 1 ? '1 cliente por cobrar' : `${resumen.total} clientes por cobrar`}
          {resumen.venceHoy > 0 && (
            <span style={{ fontWeight: 'normal' }}>
              {' · '}{resumen.venceHoy === 1 ? '1 vence hoy' : `${resumen.venceHoy} vencen hoy`}
            </span>
          )}
          {resumen.interesSinCobrar > 0 && (
            <span style={{ fontWeight: 'normal' }}>
              {' · '}{moneda(resumen.interesSinCobrar)} de interés sin cobrar
            </span>
          )}
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button
            onClick={onVerMorosos}
            style={{
              padding: '7px 14px', borderRadius: '6px', border: 'none',
              background: '#f59e0b', color: 'white', fontWeight: 'bold',
              cursor: 'pointer', fontSize: '13px', whiteSpace: 'nowrap'
            }}
          >
            Ver quiénes son
          </button>
          <button
            onClick={cerrar}
            title="Ocultar hasta mañana"
            style={{
              background: 'none', border: 'none', color: '#b45309',
              cursor: 'pointer', fontSize: '18px', lineHeight: 1, padding: '0 4px'
            }}
          >
            ×
          </button>
        </div>
      </div>

      {/* Los nombres, que es lo que de verdad se quiere saber. Solo los tres
          que más deben: una lista larga aquí obliga a leerla entera y hace que
          se ignore el aviso. */}
      <div style={{ marginTop: '10px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        {primeros.map(f => (
          <span
            key={f.loan_id}
            style={{
              background: 'white', border: '1px solid #fde68a', borderRadius: '6px',
              padding: '5px 10px', fontSize: '13px', color: '#92400e'
            }}
          >
            <strong>{f.name}</strong>
            <span style={{ color: '#b45309' }}>
              {' · '}{
                f.cobro.situacion === 'vence_hoy' ? 'le vence hoy'
                : `${f.diasAtraso} ${f.diasAtraso === 1 ? 'día de atraso' : 'días de atraso'}`
              }
              {' · debe '}{moneda(f.estado.interesPendiente)} de interés
            </span>
          </span>
        ))}
        {restantes > 0 && (
          <span style={{ color: '#b45309', fontSize: '13px', alignSelf: 'center' }}>
            y {restantes} más
          </span>
        )}
      </div>
    </div>
  );
}

export default AvisoDeMora;
